const SettingsSharing = () => <>hello world!</>;

export default SettingsSharing;
